// @ts-expect-error Untyped import
import { EVENTS } from '../../lib/usageTracker';
// @ts-expect-error Untyped import
import { trackEvent } from '../../lib/usageTracker';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { useSendOnCopilotChannel } from 'copilot-toolkit/channel/hooks/useSendOnCopilotChannel';
import { jsx as _jsx } from "react/jsx-runtime";
export const AiSearchResultsEmpty = () => {
  const openPromptTemplate = useSendOnCopilotChannel('OPEN_PROMPT_TEMPLATE');
  const handleOpenCopilotClick = () => {
    trackEvent(EVENTS.clickGenerateReportWithCopilot, {
      prompt: 'generate_a_report'
    });
    openPromptTemplate({
      promptTemplateId: 'generate_a_report'
    });
  };
  return /*#__PURE__*/_jsx(Flex, {
    justifyContent: "center",
    flexGrow: 1,
    children: /*#__PURE__*/_jsx(ErrorMessage, {
      illustration: "empty-state-charts",
      title: /*#__PURE__*/_jsx(Text, {
        as: "p",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reports.aiSearch.noResults"
        })
      }),
      children: /*#__PURE__*/_jsx(Text, {
        as: "p",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: 'reports.aiSearch.noResultsCopilotPrompt_jsx',
          options: {
            onClick: handleOpenCopilotClick,
            use: 'link'
          },
          elements: {
            Link: Button
          }
        })
      })
    })
  });
};
export default AiSearchResultsEmpty;